// src/hooks/useSyncStatus.js
import { useEffect, useState } from 'react';
import { addPendingUpdate, getAllPendingUpdates, clearPendingUpdates } from '../utils/indexedDB';
import axios from 'axios';

const API_URL = 'https://api.exemplo.com/status'; // URL da API para sincronizar
const CHECK_CONNECTION_URL = 'https://www.google.com/favicon.ico'; // Recurso leve para testar conexão

const API_BASE_URL = process.env.REACT_APP_API_URL;
const API_AUTH = {
  username: process.env.REACT_APP_API_USER,
  password: process.env.REACT_APP_API_PASSWORD,
};

const useSyncStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [isSyncing, setIsSyncing] = useState(false);
  const companyUuid = localStorage.getItem('companyUuid') || ''; // Recupera o companyUuid do storage

  const checkConnection = async () => {
    try {
      await fetch(CHECK_CONNECTION_URL, { method: 'HEAD', mode: 'no-cors' });
      setIsOnline(true);
    } catch (error) {
      setIsOnline(false);
    }
  };

  useEffect(() => {
    const syncPendingUpdates = async () => {
      await checkConnection(); // Verifica conexão real

      if (isOnline) {
        const pendingUpdates = await getAllPendingUpdates();

        // console.log('pendingUpdates', pendingUpdates)
        
        if (pendingUpdates.length > 0) {
          console.log(30)
          setIsSyncing(true);
          try {
            await Promise.all(
              pendingUpdates.map((update) =>
                axios.post(API_BASE_URL+'status/change', update, {
                  headers: {
                    c: companyUuid,
                    Authorization: `Basic ${btoa(`${API_AUTH.username}:${API_AUTH.password}`)}`,
                  },
                })
              )
            );
            await clearPendingUpdates();
          } catch (error) {
            console.error('Erro ao sincronizar:', error);
          } finally {
            setIsSyncing(false);
          }
        }
      }
    };

    syncPendingUpdates();
    window.addEventListener('online', syncPendingUpdates);
    window.addEventListener('offline', () => setIsOnline(false));

    // Verifica conexão a cada 5 segundos
    const interval = setInterval(checkConnection, 30000);

    return () => {
      window.removeEventListener('online', syncPendingUpdates);
      window.removeEventListener('offline', () => setIsOnline(false));
      clearInterval(interval);
    };
  // eslint-disable-next-line
  }, [isOnline]);

  const updateStatus = async (userId, status) => {
    const update = { userId, status, timestamp: new Date().toISOString() };

    await checkConnection(); // Garante que a conexão é válida

    if (isOnline) {
      setIsSyncing(true);
      try {
        await fetch(API_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(update),
        });
      } catch (error) {
        console.error('Erro ao atualizar online:', error);
        await addPendingUpdate(update);
      } finally {
        setIsSyncing(false);
      }
    } else {
      await addPendingUpdate(update);
      setIsOnline(false);
    }
  };

  return { updateStatus, isOnline, isSyncing };
};

export default useSyncStatus;
